import React, { useContext, useEffect, useState } from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import CardClientes from "../components/Cards/CardClientes";
import CardColaboradores from "../components/Cards/CardColaboradores";
import CardHistoricoUsuarios from "../components/Cards/CardHistoricoUsuarios";
import CardMensagens from "../components/Cards/CardMensagens";
import { motion } from "framer-motion";
import { AuthContext } from "../Contexts/AuthContext";
import { API_BASE_URL } from "../services/api";
import { normalizeAdminPermissions } from "../utils/adminPermissions";

export default function Admin() {
  const [colaboradores, setColaboradores] = useState([]);
  const navigate = useNavigate();
  const { usuario } = useContext(AuthContext);
  const permissoes = normalizeAdminPermissions(usuario);
  const superAdmin = usuario?.tipoUsuario === "super";
  const adminPleno = usuario?.tipoUsuario === "admin_pleno";
  const podeVerClientes =
    superAdmin || permissoes.verClientesAtivos || permissoes.verClientesDesativos;
  const podeAtivar = superAdmin || permissoes.podeAtivarClientes;
  const podeUsarFerramentasAdmin = superAdmin || adminPleno;

  // 🔥 FUNÇÃO AGORA DENTRO DO COMPONENTE
  async function mostrarColaboradores() {
    const token = localStorage.getItem("token");

    try {
      const dados = await axios.get(
        `${API_BASE_URL}/usuariosids`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (dados) {
        setColaboradores(dados.data);
      }

    } catch (erro) {
      console.log(erro);
    }
  }

  // 🔥 useEffect correto
  useEffect(() => {
    mostrarColaboradores();
  }, []);

  const propsCardPlanos = { descricao: "Clientes" };
  const propsCardPagamento = { descricao: "Activar Cliente" };
  const propsCardMessage = { descricao: "BroadCast" };
  const propsCardHistorico = { descricao: "Histórico" };

  return (
    <motion.div
      className="flex flex-col justify-between min-h-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Navbar */}
      <div className="bg-blue-500 h-[200px] lg:h-[240px]">
        <NavBar />
      </div>

      {/* Conteúdo Principal */}
      <div className="w-full px-1 sm:px-8 mx-auto flex justify-center -mt-[70px] lg:-mt-[150px] lg:z-10">
        <motion.div
          className="flex flex-col items-center gap-6 lg:flex-row lg:justify-center"
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.15 },
            },
          }}
        >
          {podeVerClientes && (
            <motion.div className="w-full sm:w-[80%] lg:w-1/3">
              <button onClick={() => navigate("clientes")} className="w-full">
                <CardClientes {...propsCardPlanos} />
              </button>
            </motion.div>
          )}

          {podeAtivar && (
            <motion.div className="w-full sm:w-[80%] lg:w-1/3">
              <button onClick={() => navigate("colaboradores")} className="w-full">
                <CardColaboradores {...propsCardPagamento} />
              </button>
            </motion.div>
          )}

          {podeUsarFerramentasAdmin && (
          <motion.div className="w-full sm:w-[80%] lg:w-1/3">
            <button onClick={() => navigate("broadcast")} className="w-full">
              <CardMensagens {...propsCardMessage} />
            </button>
          </motion.div>
          )}

          {podeUsarFerramentasAdmin && (
          <motion.div className="w-full sm:w-[80%] lg:w-1/3">
            <button onClick={() => alert("Em Manutenção")} className="w-full">
              <CardHistoricoUsuarios {...propsCardHistorico} />
            </button>
          </motion.div>
          )}
        </motion.div>
      </div>

      {/* Footer */}
      <div className="bg-blue-500 mt-8">
        <Footer />
      </div>
    </motion.div>
  );
}
